@let user = $user | async;
<!---->
@let fetched = $usersFetched | async;

<mat-card>
  <mat-card-content>
    @if (!fetched) {
    <loading title="Fetching user..." />
    }
    <!---->
    @if (user) {
    <div class="flex">
      <div class="left h-100">
        <div>
          <div
            (click)="setTab('profile')"
            [class.active]="currentTab === 'profile'"
            class="tab"
          >
            Profile
          </div>
          <div
            (click)="setTab('address')"
            [class.active]="currentTab === 'address'"
            class="tab"
          >
            Address
          </div>
          <div
            (click)="setTab('documents')"
            [class.active]="currentTab === 'documents'"
            class="tab"
          >
            Documents
          </div>
          <div
            (click)="setTab('banking-details')"
            [class.active]="currentTab === 'banking-details'"
            class="tab"
          >
            Banking Details
          </div>
          <div
            (click)="setTab('signed-contract')"
            [class.active]="currentTab === 'signed-contract'"
            class="tab"
          >
            Signed Contract
          </div>
          <div
            (click)="setTab('vehicle')"
            [class.active]="currentTab === 'vehicle'"
            class="tab"
          >
            Vehicle
          </div>
          <div
            (click)="setTab('trips')"
            [class.active]="currentTab === 'trips'"
            [ngClass]="{'tab': !!user.vehicle, 'tab-disabled' : !user.vehicle }"
          >
            Trips
          </div>
          <div
            (click)="setTab('driver-behavior')"
            [class.active]="currentTab === 'driver-behavior'"
            [ngClass]="{'tab': !!user.vehicle, 'tab-disabled' : !user.vehicle }"
          >
            Driving Behavior
          </div>
          <div
            (click)="setTab('inspections')"
            [class.active]="currentTab === 'inspections'"
            [ngClass]="{'tab': !!user.vehicle, 'tab-disabled' : !user.vehicle }"
          >
            Inspections
          </div>
          <div
            (click)="setTab('expenses')"
            [class.active]="currentTab === 'expenses'"
            class="tab"
          >
            Expenses
          </div>
          <div
            (click)="setTab('statements')"
            [class.active]="currentTab === 'statements'"
            class="tab"
          >
            Statements
          </div>
          <div
            (click)="setTab('criminal-background-check')"
            [class.active]="currentTab === 'criminal-background-check'"
            class="tab"
          >
            Criminal Background Check
          </div>
        </div>

        <div class="my-3">
          <hr />
        </div>

        <div class="pb-4 px-3 pe-4">
          <div class="status-row">
            <div>User Status:</div>
            <mat-icon [ngClass]="isUserApproved(user) ? 'green' : 'red'">
              {{isUserApproved(user) ? 'check_circle' : 'cancel'}}
            </mat-icon>
          </div>

          <div class="my-3">
            <hr />
          </div>

          <div class="status-row mb-2">
            <div>Profile</div>
            <mat-icon [ngClass]="isProfileApproved(user) ? 'green' : 'red'">
              {{isProfileApproved(user) ? 'check_circle' : 'cancel'}}
            </mat-icon>
          </div>
          <div class="status-row mb-2">
            <div>Address</div>
            <mat-icon [ngClass]="isAddressApproved(user) ? 'green' : 'red'">
              {{isAddressApproved(user) ? 'check_circle' : 'cancel'}}
            </mat-icon>
          </div>
          <div class="status-row mb-2">
            <div>Documents</div>
            <mat-icon
              [ngClass]="areDocumentsApprovedAndValid(user) ? 'green' : 'red'"
            >
              {{areDocumentsApprovedAndValid(user) ? 'check_circle' : 'cancel'}}
            </mat-icon>
          </div>
          <div class="status-row mb-2">
            <div>Banking Details</div>
            <mat-icon [ngClass]="hasBankingDetails(user) ? 'green' : 'red'">
              {{hasBankingDetails(user) ? 'check_circle' : 'cancel'}}
            </mat-icon>
          </div>
          <div class="status-row mb-2">
            <div>Signed Contract</div>
            <mat-icon [ngClass]="hasSignedContract(user) ? 'green' : 'red'">
              {{hasSignedContract(user) ? 'check_circle' : 'cancel'}}
            </mat-icon>
          </div>
          <div class="status-row mb-2">
            <div>Criminal Record Check</div>
            <mat-icon
              [ngClass]="isCriminalRecordCheckApproved(user) ? 'green' : 'red'"
            >
              {{isCriminalRecordCheckApproved(user) ? 'check_circle' :
              'cancel'}}
            </mat-icon>
          </div>
          <div class="status-row mb-2">
            <div>Car Track Profile</div>
            <mat-icon [ngClass]="hasCartTrackAccount(user) ? 'green' : 'red'">
              {{hasCartTrackAccount(user) ? 'check_circle' : 'cancel'}}
            </mat-icon>
          </div>
          <div class="status-row mb-2">
            <div>Assigned Vehicle</div>
            <mat-icon
              [ngClass]="hasAssignedApproveVehicle(user) ? 'green' : 'red'"
            >
              {{hasAssignedApproveVehicle(user) ? 'check_circle' : 'cancel'}}
            </mat-icon>
          </div>
        </div>
      </div>

      @if (currentTab == 'profile') {
      <div class="right">
        <app-user-profile
          [user]="user"
          (createCarTrackProfile)="onCreateCarTrackProfile()"
        />
      </div>
      } @if (currentTab == 'address') {
      <div class="right">
        <app-user-address [user]="user" />
      </div>
      } @if (currentTab == 'documents') {
      <div class="right">
        <app-user-documents [user]="user!" />
      </div>
      } @if (currentTab == 'vehicle') {
      <div class="right">
        <app-user-vehicle [user]="user" (setTab)="setTab($event)">
        </app-user-vehicle>
      </div>
      } @if (currentTab == 'inspections') {
      <div class="right">
        <app-user-inspections [user]="user" />
      </div>
      } @if (currentTab == 'expenses') {
      <div class="right">
        <app-user-expenses [user]="user" />
      </div>
      } @if (currentTab == 'trips') {
      <div class="right">
        <app-trips [user]="user" />
      </div>
      } @if (currentTab == 'driver-behavior') {
      <div class="right">
        <app-user-driving-behavior [user]="user" />
      </div>
      } @if (currentTab == 'statements') {
      <div class="right">
        <app-user-statements
          [user]="user"
          [statementId]="statementId"
          (statementClicked)="statementClicked($event)"
        />
      </div>
      } @if (currentTab == 'signed-contract') {
      <div class="right">
        <app-user-contract [user]="user" [latestContract]="contract" />
      </div>
      } @if (currentTab == 'banking-details') {
      <div class="right">
        <app-user-banking-details [user]="user"> </app-user-banking-details>
      </div>
      } @if (currentTab == 'criminal-background-check') {
      <div class="right">
        <app-user-criminal-record-check
          [user]="user"
          [criminalRecordCheckDocument]="criminalRecordCheckDocument"
        >
        </app-user-criminal-record-check>
      </div>
      }
    </div>
    }
  </mat-card-content>
</mat-card>
